<template>
  <div>
    <v-bottom-sheet
      v-model="sheet"
      hide-overlay
      persistent
    >
      <v-sheet
        class="px-3"
        :style="`max-height:${windowHeight/2}px;overflow-y:auto`"
      >
        <map-legend
          v-if="hasLegend && tab===0"
          dense
        />
        <filters
          v-show="tab === (hasLegend ? 1 : 0)"
          dense
          class="pt-2"
        />
        <selected-infos
          v-if="tab === (hasLegend ? 2 : 1)"
          dense
        />
        <div style="height:60px" />
      </v-sheet>
    </v-bottom-sheet>
    <v-bottom-navigation
      v-model="tab"
      style="z-index:300"
      :color="sheet ? 'primary' : ''"
    >
      <v-btn
        v-if="hasLegend"
        style="min-width:120px"
        small
        class="pa-0"
        @click="toggleSheet"
      >
        <span>Légende</span><v-icon>mdi-format-list-bulleted-square</v-icon>
      </v-btn>
      <v-btn
        style="min-width:120px"
        small
        class="pa-0"
        @click="toggleSheet"
      >
        <span>Recherche</span><v-icon>mdi-magnify</v-icon>
      </v-btn>
      <v-btn
        v-if="(parcel && !config.hideParcelsInfos) || (features && features.length)"
        style="min-width:120px"
        small
        class="pa-0"
        @click="toggleSheet"
      >
        <span>Sélection</span><v-icon>mdi-selection-marker</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </div>
</template>

<script>
import SelectedInfos from './sections/selected-infos.vue'
import Filters from './sections/filters.vue'
import MapLegend from './sections/map-legend.vue'
import { mapState, mapGetters } from 'vuex'

export default {
  components: {
    SelectedInfos,
    Filters,
    MapLegend
  },
  data () {
    return {
      sheet: true,
      tab: 0
    }
  },
  computed: {
    ...mapState(['parcel', 'features']),
    ...mapGetters(['config']),
    hasLegend () {
      return this.config && this.config.colorField && this.config.colorField.length
    }
  },
  watch: {
    parcel (value) {
      this.sheet = !!this.parcel || !!(value && value.length)
      if (this.sheet) this.tab = this.hasLegend ? 2 : 1
      else this.tab = null
    },
    features (value) {
      this.sheet = !!this.parcel || !!(value && value.length)
      if (this.sheet) this.tab = this.hasLegend ? 2 : 1
      else this.tab = null
    },
    tab (newV, oldV) {
      this.sheet = (newV !== null && oldV !== null)
    }
  },
  methods: {
    toggleSheet (e) {
      this.sheet = !this.sheet
    }
  }
}
</script>

<style lang="css" scoped></style>
